module.exports = "/_assets/images/branding/corval-hex-pattern-tile-light.svg";